import { VERTICAL } from '~/helpers/vertical.constants'

export const usePostsStore = defineStore('posts', {
  state: () => ({
    posts: {
      [VERTICAL.HEALTH_INSURANCE]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      [VERTICAL.LIFE_INSURANCE]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      [VERTICAL.CREDIT_CARDS]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0,
        fieldVerticalPayload: [VERTICAL.CREDIT_CARDS, VERTICAL.PERSONAL_LOANS, VERTICAL.CAR_LOANS]
      },
      [VERTICAL.HOME_LOANS]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      [VERTICAL.ENERGY]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      [VERTICAL.CAR_INSURANCE]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      [VERTICAL.TRAVEL_INSURANCE]: {
        items: [],
        perPage: 12,
        totalActivePost: 0,
        maxPosts: 0
      },
      activeVertical: VERTICAL.HEALTH_INSURANCE
    }
  }),

  actions: {
    async initialize () {
      const $route = useRoute()

      const _vertical = (() => {
        if ($route.fullPath.includes('/credit-cards/guides')) {
          return 'Credit Cards'
        }

        if ($route.fullPath.includes('/travel-insurance/guides')) {
          return 'Travel Insurance'
        }

        return $route.params?.vertical
      })()

      if (_vertical) {
        const vertical = strToCapitalize(_vertical.replace(/-/g, ' '))
        this.posts.activeVertical = vertical
      }

      //added optional chaining to avoid error when items is undefined
      if (this.posts[this.posts.activeVertical]?.items?.length === 0) {
        await this.LOAD_POSTS()
      }
    },

    async LOAD_POSTS () {
      const postsData = this.posts
      const activeVertical = this.posts.activeVertical
      const postsDataActiveVertical = postsData[activeVertical]
      const limit = postsDataActiveVertical.perPage
      const skip = postsDataActiveVertical.totalActivePost
      let verticals = [activeVertical]
      if (typeof postsDataActiveVertical.fieldVerticalPayload !== 'undefined') {
        verticals = postsDataActiveVertical.fieldVerticalPayload
      }

      const guidesStore = useGuidesStore()
      const postsItems = await guidesStore.fetchArticlesByVertical(verticals, limit, skip).then(response => {
        // commit('SET_MAX_POSTS', response.total)
        this.posts[this.posts.activeVertical].maxPosts = response?.total ?? 0
        return response?.items ?? []
      })

      // await commit('UPDATE_TOTAL_ACTIVE_POST')
      this.posts[this.posts.activeVertical].totalActivePost = this.posts[this.posts.activeVertical].totalActivePost + this.posts[this.posts.activeVertical].perPage

      // commit('PUSH_POSTS_ITEM', posts)
      this.posts[this.posts.activeVertical].items = [...this.posts[this.posts.activeVertical].items, ...postsItems]
    }
  },
  getters: {
    GET_POSTS: state => {
      return state.posts[state.posts.activeVertical].items
    },
    GET_POST_PERPAGE: state => {
      return state.posts[state.posts.activeVertical].perPage
    },
    GET_TOTAL_ACTIVE_POST: state => {
      return state.posts[state.posts.activeVertical].totalActivePost
    },
    GET_MAX_POSTS: state => {
      return state.posts[state.posts.activeVertical].maxPosts
    },
    GET_ACTIVE_VERTICAL: state => {
      return state.posts.activeVertical
    }
  }
})
